/* global axios */
import ApiClient from '../ApiClient';

// Cross-account — not accountScoped on purpose, see backend
// Api::V1::SuperAdmin::AccountsController (gated on current_user.super_admin?, not account
// membership). Precedent for a non-accountScoped client: dashboard/api/changelog.js.
class SuperAdminAccountsAPI extends ApiClient {
  constructor() {
    super('super_admin/accounts', { apiVersion: 'v1' });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new SuperAdminAccountsAPI();
